import React from "react"

function Feature(props) {
  return (
    <div>
      <div className="icon text-primary mb-3">
        <img width="48" height="48" src={props.iconpath} alt=""/>
      </div>
      <h3>{props.title}</h3>
      <p className="text-muted mb-6 mb-md-0">{props.description}</p>
    </div>
  )
}

export default Feature